export const translations = {
  en: {
    // Navigation
    nav: {
      aboutUs: 'About Us',
      ourBusiness: 'Our Business',
      ourManagement: 'Our Management',
      projectPipeline: 'Project Pipeline',
      career: 'Career',
      contactUs: 'Contact Us',
    },

    // Home Page
    home: {
      heroTagline: 'Alternative Investment',
      heroSubtitle: 'Enduring growth through industrial real estate development and management',
      getInTouch: 'Get in Touch',
      learnMore: 'Learn More',

      // About Section
      aboutTitle: 'About',
      aboutTitleBold: 'VentuNext',
      aboutPara1: 'VentuNext is an industrial and logistics real estate investment platform focused on Southeast Asia and other high-growth emerging markets. We invest in, develop and manage next-generation logistics and manufacturing infrastructure, with an emphasis on resilient supply chains, operational efficiency and sustainable growth.',
      aboutPara2: 'We integrate capabilities across investment and portfolio management, land sourcing and development, automated and sustainable facility delivery, and institutional-grade asset management. Our platform operates under international governance standards, supported by disciplined investment processes, robust risk management and transparent stakeholder engagement.',
      aboutPara3: 'Our first project, a 26,000-square-metre logistics park in Rayong, commenced construction in December 2025 and is scheduled for delivery in Q3 2026, marking a key milestone in the Company\'s development journey.',

      // Our People Section
      peopleTitle: 'Our',
      peopleTitleBold: 'People',
      peoplePara1: 'Our founding team includes senior executives from leading global industrial developers and fund management institutions, with deep experience across Asia\'s logistics and manufacturing hubs. Collectively, the team has managed industrial and logistics real estate portfolios exceeding USD 10 billion.',
      peoplePara2: 'Over the past decades, the team has delivered landmark projects for Fortune Global 500 companies and multinational clients, spanning distribution centres, build-to-suit industrial facilities and long-term asset management solutions.',

      // Vision Section
      visionTitle: 'Our Vision',
      visionSubtitle: 'VentuNext is committed to disciplined investing, operational excellence and deep sector insight, creating lasting value for our investors, clients and people.',
      forInvestors: 'For Investors',
      forClients: 'For Clients',
      forEmployees: 'For Employees',
      investor1: 'Deliver attractive, sustainable long-term returns through disciplined investment frameworks',
      investor2: 'Build a high-quality, scalable and cross-regional industrial and logistics portfolio',
      investor3: 'Uphold institutional standards of governance, transparency and risk management',
      client1: 'Provide best-in-class warehouses and manufacturing facilities designed for scalability and efficiency',
      client2: 'Support regional expansion with automation, smart infrastructure and sustainable energy solutions',
      client3: 'Act as a long-term strategic partner in supply chain and manufacturing transformation',
      employee1: 'Offer an engaging, inclusive and high-performance environment with clear career pathways',
      employee2: 'Enable cross-regional and cross-functional development opportunities',
      employee3: 'Foster an international, transparent culture that values ownership, collaboration and excellence',

      // Contact Section
      contactTitle: 'Contact Us',
      contactSubtitle: 'We welcome enquiries from investors, clients and professionals interested in opportunities with VentuNext.',
    },

    // Business Page
    business: {
      heroTag: 'What We Do',
      heroTitle: 'Our Business',
      heroSubtitle: 'Comprehensive solutions across the industrial real estate value chain',

      bts: {
        title: 'Built-to-Suit Industrial Facility',
        description: 'We develop built-to-suit industrial facilities tailored to each client\'s operational needs, from layout planning and specification design to permitting and construction delivery. Our team integrates automation readiness, ESG considerations, and cost-and-schedule discipline to help occupiers ramp up faster and operate more efficiently.',
      },
      readyBuilt: {
        title: 'Ready-Built Logistics Park',
        description: 'We deliver ready-built logistics parks in strategic industrial clusters, offering flexible unit options that support immediate move-in and scalable growth. With institutional-grade standards in safety, utilities, and park operations, we help tenants secure reliable space while maintaining long-term asset quality.',
      },
      assetMgmt: {
        title: 'Real Estate Asset Management',
        description: 'We provide end-to-end asset management to protect and enhance property value, including leasing strategy, tenant relationship management, budgeting, and performance reporting. Our focus is stable cash flow, high occupancy, and disciplined capex planning—supported by transparent governance and risk management.',
      },
      fundMgmt: {
        title: 'Private Fund Management',
        description: 'We structure and manage private real estate investment vehicles for qualified investors, with clear underwriting standards, robust deal execution, and ongoing portfolio oversight. Our objective is to deliver attractive risk-adjusted returns through disciplined asset selection, active management, and well-timed exits.',
      },

      ctaTitle: 'Partner With Us',
      ctaSubtitle: 'Whether you\'re looking for industrial facilities, investment opportunities, or asset management services, we\'re here to help.',
    },

    // Team Page
    team: {
      heroTag: 'Leadership',
      heroTitle: 'Our Management',
      heroSubtitle: 'Experienced leaders building next-generation industrial infrastructure',

      introPara1: 'Our founding team includes senior executives from leading global industrial developers and fund management institutions, with deep experience across Asia\'s logistics and manufacturing hubs. Collectively, the team has managed industrial and logistics real estate portfolios exceeding USD 10 billion.',
      introPara2: 'Over the past decades, the team has delivered landmark projects for Fortune Global 500 companies and multinational clients, spanning distribution centres, build-to-suit industrial facilities and long-term asset management solutions.',

      education: 'Education',

      pengTao: {
        name: 'Peng-Tao Zhang',
        title: 'Managing Director',
        bio: [
          'Peng-Tao Zhang is the Co-Founder and Managing Director of VentuNext, where he has spearheaded the company\'s rapid growth in the Asia Pacific industrial real estate sector and led investments valued at billions of Thai Baht. He is responsible for the company\'s daily operational management, investment strategy formulation, and regional business expansion.',
          'Prior to establishing VentuNext, Peng-Tao served as Managing Director of a leading industrial real estate platform, where he directed the end-to-end development of Southeast Asia\'s largest fully automated warehouse project, which stands as one of the world\'s largest of its kind.',
          'Earlier in his career, he drove Southeast Asia expansion for YunExpress, scaled leasing and business development at GLP across over one million square meters of logistics assets, and led global accounts at FedEx Asia Pacific.'
        ],
        education: 'Peng-Tao holds a Bachelor\'s degree in Economics from Chongqing University, a Master\'s degree in International Banking and Finance from Lingnan University, and a Master\'s degree in Supply Chain and Logistics Management from the University of Warwick.'
      },

      kane: {
        name: 'Kane Chen',
        title: 'Executive Director',
        bio: [
          'Kane Chen is Co-Founder and Executive Director at VentuNext, with over 25 years of experience in industrial and logistics facilities development. He supports the firm\'s engineering strategy and project delivery across Thailand and Southeast Asia.',
          'Before joining VentuNext, Kane founded and led an engineering firm specialising in large-scale industrial and logistics projects, delivering more than three million square metres of facilities for leading logistics platforms, manufacturers and supply chain operators. He began his career at Butler / BlueScope, where he gained a strong foundation in international engineering standards and project governance.'
        ],
        education: 'Kane holds a degree in Construction Machinery from the Chongqing Institute of Architecture and Engineering.'
      },

      ctaTitle: 'Join Our Team',
      ctaSubtitle: 'We\'re always looking for talented professionals to join our growing team',
      viewCareers: 'View Career Opportunities',
    },

    // Pipeline Page
    pipeline: {
      heroTag: 'Our Projects',
      heroTitle: 'Project Pipeline',
      heroSubtitle: 'Strategic logistics developments across high-growth markets',

      dubai: {
        name: 'VentuNext Dubai Logistics Park',
        location: 'Dubai, UAE',
        gfa: '60,000 sq.m. GFA',
        target: 'Targeted for multinational logistics operators',
        investment: 'Total Investment: USD 90 million',
      },
      samutPrakan: {
        name: 'VentuNext Samut Prakan Logistics Park',
        location: 'Samut Prakan, Thailand (EEC)',
        gfa: '100,000 sq.m. GFA',
        target: 'Targeted for multinational logistics operators & brand owners',
        investment: 'Total Investment: USD 55 million',
      },
      samutSakhon: {
        name: 'VentuNext Samut Sakhon Logistics Park',
        location: 'Samut Sakhon, Thailand',
        gfa: '40,000 sq.m. GFA',
        target: 'Targeted for multinational logistics operators',
        investment: 'Total Investment: USD 25 million',
      },

      ctaTitle: 'Interested in Our Projects?',
      ctaSubtitle: 'We welcome enquiries from investors and clients interested in our pipeline opportunities.',
    },

    // Career Page
    career: {
      heroTag: 'Join Us',
      heroTitle: 'Career',
      heroSubtitle: 'Build Your Career in Industrial Real Estate Investment',

      programTitle: 'Building Pioneering, Value Focused',
      programTitleBold: 'Future Leaders',
      programPara1: 'The NextLeap Investment Manager Programme is VentuNext\'s two year, end to end development journey for early career talent with a strong passion for investment and asset management. Through real deal exposure and cross functional learning, you will build a practical foundation in real asset management, with a focus on industrial and logistics real estate.',
      programPara2: 'This is your opportunity to connect your strengths and ambitions to our shared purpose: creating long term value for our stakeholders through sustainable, responsible growth and investments, while enabling resilient, thriving communities.',
      programPara3: 'At VentuNext, our Investment and Asset Management teams are key growth engines. They sit at the centre of our strategy and execution, driving disciplined performance, operational excellence, and long term economic value, while contributing positively to the environmental and social wellbeing of the people and places we serve.',

      offerTitle: 'What We Offer',
      offerSubtitle: 'Join a team that invests in your growth',

      benefit1Title: 'High-Performance Environment',
      benefit1Desc: 'An engaging, inclusive and high-performance work environment with clear career pathways.',
      benefit2Title: 'Real Ownership',
      benefit2Desc: 'Move fast, and accelerate your career through outsized responsibilities and cross-regional opportunities',
      benefit3Title: 'International Exposure',
      benefit3Desc: 'An international, transparent culture that values ownership, collaboration and excellence.',
      ctaTitle: 'Interested in Joining Us?',
      ctaSubtitle: 'We welcome enquiries from professionals interested in opportunities with VentuNext. Please get in touch with us to learn more about current openings.',
    },

    // Contact Page
    contact: {
      heroTag: 'Get in Touch',
      heroTitle: 'Contact Us',
      heroSubtitle: 'We welcome enquiries from investors, clients and professionals interested in opportunities with VentuNext.',

      formIntro: 'Please complete the form below and our team will get in touch with you as soon as possible.',

      steps: {
        name: "What's your name?",
        namePlaceholder: 'Enter your full name',
        email: "What's your email address?",
        emailPlaceholder: 'your@email.com',
        company: "Which company are you from?",
        companyPlaceholder: 'Company name (optional)',
        enquiryType: "What type of enquiry is this?",
        enquiryPlaceholder: 'Please select...',
        message: "How can we help you?",
        messagePlaceholder: 'Tell us more about your enquiry...',
      },

      enquiryTypes: {
        investor: 'Investor Enquiry',
        client: 'Client Enquiry',
        career: 'Career Opportunity',
        other: 'Other',
      },

      required: 'This field is required',
      back: 'Back',
      continue: 'Continue',
      submit: 'Submit',
      thankYou: 'Thank you for your enquiry. Our team will get in touch with you as soon as possible.',
    },

    // Footer
    footer: {
      tagline: 'Investing in the future of industrial and logistics infrastructure.',
      company: 'Company',
      about: 'About',
      vision: 'Vision',
      resources: 'Resources',
      ourTeam: 'Our Team',
      careers: 'Careers',
      contact: 'Contact',
      getInTouch: 'Get in Touch',
      location: 'Bangkok, Thailand',
      rights: 'VentuNext. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
  },

  zh: {
    // Navigation
    nav: {
      aboutUs: '关于我们',
      ourBusiness: '我们的业务',
      ourManagement: '管理团队',
      projectPipeline: '项目储备',
      career: '职业发展',
      contactUs: '联系我们',
    },

    // Home Page
    home: {
      heroTagline: '另类投资 · 基业长青',
      heroSubtitle: '以工业地产开发与管理驱动长期增长',
      getInTouch: '联系我们',
      learnMore: '了解更多',

      // About Section
      aboutTitle: '关于',
      aboutTitleBold: 'VentuNext',
      aboutPara1: 'VentuNext 是一家专注于东南亚及其他高增长新兴市场的工业与物流地产投资平台。我们投资、开发并管理新一代物流与制造基础设施，重点关注供应链韧性、运营效率与可持续增长。',
      aboutPara2: 'VentuNext 以投资与资产管理为核心，覆盖土地获取与开发、自动化与可持续设施交付以及机构级资产管理等全链条能力。我们遵循国际化治理标准，以严谨的投资纪律、稳健的风险管理与透明的利益相关方沟通为基础开展业务。',
      aboutPara3: '公司首个项目为位于罗勇府的物流园区，总建筑面积约 26,000 平方米，已于 2025 年 12 月正式动工，计划于 2026 年第三季度交付，标志着公司发展进程中的重要里程碑。',

      // Our People Section
      peopleTitle: '我们的团队',
      peopleTitleBold: '',
      peoplePara1: '我们的创始团队由来自全球领先工业地产开发商与基金管理机构的资深管理者组成，深耕亚洲关键物流与制造枢纽。团队累计管理的工业与物流地产资产组合规模超过 100 亿美元。',
      peoplePara2: '过去数十年间，团队交付了多项标杆项目，并为世界 500 强及跨国企业提供服务，覆盖区域分拨中心、定制化（BTS）制造设施以及长期资产管理解决方案。',

      // Vision Section
      visionTitle: '我们的愿景',
      visionSubtitle: 'VentuNext 坚持长期主义，致力于以严谨投资、卓越运营与深度行业洞察，为投资人、客户与团队创造可持续的长期价值。',
      forInvestors: '为投资人',
      forClients: '为客户',
      forEmployees: '为员工',
      investor1: '通过严谨的投资框架，提供具吸引力且可持续的长期回报',
      investor2: '构建高质量、可扩展、跨区域的工业与物流资产组合',
      investor3: '坚持机构级治理、透明度与风险管理标准',
      client1: '提供面向增长与运营效率的高标准仓储及制造设施',
      client2: '以自动化、智慧基础设施与可持续能源方案支持区域扩张',
      client3: '作为供应链与制造升级转型的长期战略伙伴',
      employee1: '打造积极、多元、绩效导向的工作环境与清晰的职业发展路径',
      employee2: '提供跨区域、跨职能的成长与发展机会',
      employee3: '建立国际化、透明的文化，倡导主人翁精神、协作与卓越',

      // Contact Section
      contactTitle: '联系我们',
      contactSubtitle: '欢迎有兴趣与 VentuNext 开展合作的投资人、企业客户，以及希望加入我们的专业人才与我们联系。',
    },

    // Business Page
    business: {
      heroTag: '我们的业务',
      heroTitle: '业务范围',
      heroSubtitle: '覆盖工业地产价值链的综合解决方案',

      bts: {
        title: '定制化工业设施',
        description: '我们为客户量身定制建设工业设施，从需求梳理、方案与规范设计、报批报建到施工交付提供一体化服务。项目在规划阶段即融入自动化、ESG与可持续要素，并以严格的成本与工期管理，帮助客户更快投产、提升运营效率。',
      },
      readyBuilt: {
        title: '已建成标准仓库',
        description: '我们在核心产业与物流集群打造标准化、可快速入住的物流园与现成仓库产品，支持客户灵活扩租与快速扩张。园区以机构级标准建设与运营，覆盖安全、配套公用设施与物业管理，确保租户体验与资产品质长期稳定。',
      },
      assetMgmt: {
        title: '不动产资产管理',
        description: '我们提供全周期资产管理服务，包括招商与租赁策略、租户关系维护、年度预算与资本开支计划、以及经营表现的透明报告。通过精细化运营与风险管理，我们致力于实现高入住率、稳健现金流，并持续提升资产价值。',
      },
      fundMgmt: {
        title: '私募不动产基金管理',
        description: '我们为合格投资者设立并管理私募不动产基金与投资载体，采用清晰的投资策略、严格的尽调与投决流程，并具备强执行力的投后管理。目标是在控制风险的前提下，通过优质资产筛选、主动管理与适时退出，为投资人创造具吸引力的风险调整后回报。',
      },

      ctaTitle: '与我们合作',
      ctaSubtitle: '无论您是寻找工业设施、投资机会还是资产管理服务，我们都能为您提供帮助。',
    },

    // Team Page
    team: {
      heroTag: '领导团队',
      heroTitle: '管理团队',
      heroSubtitle: '经验丰富的领导者，构建新一代工业基础设施',

      introPara1: '我们的创始团队由来自全球领先工业地产开发商与基金管理机构的资深管理者组成，深耕亚洲关键物流与制造枢纽。团队累计管理的工业与物流地产资产组合规模超过 100 亿美元。',
      introPara2: '过去数十年间，团队交付了多项标杆项目，并为世界 500 强及跨国企业提供服务，覆盖区域分拨中心、定制化（BTS）制造设施以及长期资产管理解决方案。',

      education: '教育背景',

      pengTao: {
        name: '张朋弢',
        title: '董事总经理',
        bio: [
          '张朋弢先生是 VentuNext 的联合创始人兼董事总经理，主导公司在亚太地区工业及物流地产领域的快速发展，累计推动投资规模达数十亿泰铢。他全面负责公司的日常运营管理、投资策略制定以及区域业务拓展。',
          '在创立 VentuNext 之前，张朋弢曾担任一家国际领先工业地产平台的董事总经理，全面主导并交付了东南亚规模最大的全自动化仓储项目，该项目亦位居全球同类项目前列。',
          '在更早期的职业生涯中，他曾负责 YunExpress 在东南亚的区域拓展；并曾就职于 GLP，主导超过百万平方米物流资产的招商与业务拓展；同时在 FedEx 亚太区负责全球重点客户管理。'
        ],
        education: '朋弢毕业于重庆大学，获经济学学士学位，其后分别于岭南大学及英国华威大学取得国际银行与金融硕士学位，以及供应链与物流管理硕士学位。'
      },

      kane: {
        name: '陈坎',
        title: '执行董事',
        bio: [
          '陈坎为VentuNext联合创始人并任执行董事，拥有逾二十五年工业与物流设施建设经验，负责支持公司在泰国及东南亚的工程策略与项目交付。',
          '在加入 VentuNext 之前，他创立并管理一家专注大型工业与物流项目的工程公司，累计交付超过三百万平方米高标准设施，客户涵盖多家领先物流平台、制造企业及供应链服务集团。其职业生涯起步于国际轻钢结构企业 Butler / BlueScope，在技术服务、结构设计与项目管理方面打下扎实基础。'
        ],
        education: '陈坎毕业于重庆建筑大学建筑机械专业。'
      },

      ctaTitle: '加入我们',
      ctaSubtitle: '我们始终在寻找优秀的专业人才加入我们成长中的团队',
      viewCareers: '查看职业机会',
    },

    // Pipeline Page
    pipeline: {
      heroTag: '我们的项目',
      heroTitle: '项目储备',
      heroSubtitle: '布局高增长市场的战略物流开发项目',

      dubai: {
        name: 'VentuNext 迪拜物流中心',
        location: '阿联酋迪拜',
        gfa: '建筑面积 60,000 平米',
        target: '目标客户：跨国物流企业及品牌方',
        investment: '总投资：9,000万美元',
      },
      samutPrakan: {
        name: 'VentuNext 北榄物流中心',
        location: '泰国北榄府，东部经济走廊EEC',
        gfa: '建筑面积 100,000 平米',
        target: '目标客户：跨国物流企业及品牌方',
        investment: '总投资：5,500万美元',
      },
      samutSakhon: {
        name: 'VentuNext 龙仔厝物流中心',
        location: '泰国龙仔厝府',
        gfa: '建筑面积 40,000 平米',
        target: '目标客户：跨国物流企业',
        investment: '总投资：2,500万美元',
      },

      ctaTitle: '对我们的项目感兴趣？',
      ctaSubtitle: '欢迎对我们项目有兴趣的投资人和客户与我们联系。',
    },

    // Career Page
    career: {
      heroTag: '加入我们',
      heroTitle: '职业发展',
      heroSubtitle: '在工业地产投资领域建立您的职业生涯',

      programTitle: '培养敢为先、重价值的',
      programTitleBold: '未来领导者',
      programPara1: 'NextLeap Investment Manager Programme 是 VentuNext 推出的两年制、系统化人才发展计划，面向对投资与资产管理充满热情的早期职业人才。项目通过真实项目参与与跨职能轮岗，帮助学员建立对真实资产管理行业的完整认知，并在工业与物流地产等核心赛道中加速成长。',
      programPara2: '你将把个人优势与职业热忱，连接到 VentuNext 的共同使命：以可持续、负责任的增长与投资方式，为投资人、客户与合作伙伴创造长期价值，并支持产业与社区的韧性发展与繁荣。',
      programPara3: 'VentuNext 的增长引擎来自我们的投资与资产管理团队。他们处于战略与执行的核心，以严谨的方法驱动业绩与运营效率，同时在我们所服务的园区、企业与社区中，持续创造积极的环境与社会影响。',

      offerTitle: '我们提供',
      offerSubtitle: '加入一个投资于您成长的团队',

      benefit1Title: '高绩效环境',
      benefit1Desc: '积极、多元、绩效导向的工作环境与清晰的职业发展路径。',
      benefit2Title: '真正的主人翁',
      benefit2Desc: '快速行动，通过超预期的责任与跨区域机会加速你的职业发展。',
      benefit3Title: '国际化视野',
      benefit3Desc: '国际化、透明的文化，倡导主人翁精神、协作与卓越。',

      ctaTitle: '有兴趣加入我们？',
      ctaSubtitle: '欢迎对 VentuNext 机会感兴趣的专业人士联系我们，了解更多当前职位信息。',
    },

    // Contact Page
    contact: {
      heroTag: '联系我们',
      heroTitle: '联系我们',
      heroSubtitle: '欢迎有兴趣与 VentuNext 开展合作的投资人、企业客户，以及希望加入我们的专业人才与我们联系。',

      formIntro: '请填写下方表单，我们的团队将尽快与您取得联系。',

      steps: {
        name: "您的姓名？",
        namePlaceholder: '请输入您的全名',
        email: "您的电子邮箱？",
        emailPlaceholder: 'your@email.com',
        company: "您来自哪家公司？",
        companyPlaceholder: '公司名称（选填）',
        enquiryType: "您的咨询类型？",
        enquiryPlaceholder: '请选择...',
        message: "我们能如何帮助您？",
        messagePlaceholder: '请详细描述您的咨询内容...',
      },

      enquiryTypes: {
        investor: '投资人咨询',
        client: '客户咨询',
        career: '职业机会',
        other: '其他',
      },

      required: '此字段为必填项',
      back: '返回',
      continue: '继续',
      submit: '提交',
      thankYou: '感谢您的咨询。我们的团队将尽快与您联系。',
    },

    // Footer
    footer: {
      tagline: '投资于工业与物流基础设施的未来。',
      company: '公司',
      about: '关于我们',
      vision: '愿景',
      resources: '资源',
      ourTeam: '团队',
      careers: '职业',
      contact: '联系',
      getInTouch: '联系我们',
      location: '泰国曼谷',
      rights: 'VentuNext. 保留所有权利。',
      privacy: '隐私政策',
      terms: '服务条款',
    },
  },

  th: {
    // Navigation
    nav: {
      aboutUs: 'เกี่ยวกับเรา',
      ourBusiness: 'ธุรกิจของเรา',
      ourManagement: 'ทีมผู้บริหาร',
      projectPipeline: 'โครงการในแผน',
      career: 'ร่วมงานกับเรา',
      contactUs: 'ติดต่อเรา',
    },

    // Home Page
    home: {
      heroTagline: 'การลงทุนทางเลือก',
      heroSubtitle: 'การเติบโตอย่างยั่งยืน ผ่านการพัฒนาและบริหารอสังหาริมทรัพย์อุตสาหกรรม',
      getInTouch: 'ติดต่อเรา',
      learnMore: 'เรียนรู้เพิ่มเติม',

      // About Section
      aboutTitle: 'เกี่ยวกับ',
      aboutTitleBold: 'VentuNext',
      aboutPara1: 'VentuNext เป็นแพลตฟอร์มการลงทุนด้านอสังหาริมทรัพย์อุตสาหกรรมและโลจิสติกส์ โดยมุ่งเน้นเอเชียตะวันออกเฉียงใต้และตลาดเกิดใหม่ที่มีการเติบโตสูงอื่น ๆ เราลงทุน พัฒนา และบริหารโครงสร้างพื้นฐานด้านโลจิสติกส์และการผลิตยุคใหม่ โดยให้ความสำคัญกับความยืดหยุ่นของซัพพลายเชน ประสิทธิภาพการดำเนินงาน และการเติบโตอย่างยั่งยืน',
      aboutPara2: 'VentuNext ผสานความสามารถแบบครบวงจร ตั้งแต่การลงทุนและการบริหารสินทรัพย์ การจัดหาและพัฒนาที่ดิน ไปจนถึงการส่งมอบโครงการที่รองรับระบบอัตโนมัติและความยั่งยืน พร้อมมาตรฐานการบริหารสินทรัพย์ระดับสถาบัน เราดำเนินงานภายใต้มาตรฐานธรรมาภิบาลสากล ด้วยกรอบการลงทุนที่มีวินัย การบริหารความเสี่ยงที่แข็งแกร่ง และการสื่อสารกับผู้มีส่วนได้ส่วนเสียอย่างโปร่งใส',
      aboutPara3: 'โครงการแรกของบริษัทเป็นโครงการโลจิสติกส์พาร์กในจังหวัดระยอง พื้นที่อาคารรวมประมาณ 26,000 ตารางเมตร เริ่มก่อสร้างในเดือนธันวาคม พ.ศ. 2568 และมีกำหนดแล้วเสร็จในไตรมาสที่ 3 ของปี พ.ศ. 2569 ซึ่งถือเป็นหมุดหมายสำคัญในการพัฒนาธุรกิจของบริษัท',

      // Our People Section
      peopleTitle: 'ทีมงาน',
      peopleTitleBold: 'ของเรา',
      peoplePara1: 'ทีมผู้ก่อตั้งประกอบด้วยผู้บริหารระดับสูงจากผู้พัฒนาอสังหาริมทรัพย์อุตสาหกรรมชั้นนำระดับโลกและสถาบันบริหารกองทุน โดยมีประสบการณ์ครอบคลุมศูนย์กลางโลจิสติกส์และการผลิตสำคัญทั่วเอเชีย โดยรวมแล้วทีมงานเคยบริหารพอร์ตอสังหาริมทรัพย์อุตสาหกรรมและโลจิสติกส์มูลค่ารวมมากกว่า 10,000 ล้านดอลลาร์สหรัฐ',
      peoplePara2: 'ตลอดหลายทศวรรษที่ผ่านมา ทีมงานได้ส่งมอบโครงการแลนด์มาร์กและสนับสนุนบริษัท Fortune Global 500 และบรรษัทข้ามชาติในหลากหลายรูปแบบ ตั้งแต่ศูนย์กระจายสินค้า โครงการโรงงานแบบสร้างตามความต้องการ (BTS) ไปจนถึงโซลูชันการบริหารสินทรัพย์ระยะยาว',

      // Vision Section
      visionTitle: 'วิสัยทัศน์ของเรา',
      visionSubtitle: 'VentuNext มุ่งมั่นในการลงทุนอย่างมีวินัย ความเป็นเลิศด้านการดำเนินงาน และความเชี่ยวชาญเชิงลึกในอุตสาหกรรม เพื่อสร้างคุณค่าอย่างยั่งยืนให้แก่นักลงทุน ลูกค้า และบุคลากรของเรา',
      forInvestors: 'สำหรับนักลงทุน',
      forClients: 'สำหรับลูกค้า',
      forEmployees: 'สำหรับพนักงาน',
      investor1: 'สร้างผลตอบแทนระยะยาวที่น่าดึงดูดและยั่งยืน ผ่านกรอบการลงทุนที่มีวินัย',
      investor2: 'สร้างพอร์ตสินทรัพย์อุตสาหกรรมและโลจิสติกส์ที่มีคุณภาพสูง ขยายขนาดได้ และครอบคลุมหลายภูมิภาค',
      investor3: 'ยึดมั่นมาตรฐานธรรมาภิบาล ความโปร่งใส และการบริหารความเสี่ยงระดับสถาบัน',
      client1: 'ส่งมอบคลังสินค้าและโรงงานมาตรฐานชั้นนำ ออกแบบเพื่อรองรับการขยายตัวและเพิ่มประสิทธิภาพการดำเนินงาน',
      client2: 'สนับสนุนการขยายธุรกิจระดับภูมิภาคด้วยระบบอัตโนมัติ โครงสร้างพื้นฐานอัจฉริยะ และโซลูชันพลังงานยั่งยืน',
      client3: 'เป็นพันธมิตรเชิงกลยุทธ์ระยะยาวในการยกระดับซัพพลายเชนและการเปลี่ยนผ่านด้านการผลิต',
      employee1: 'สร้างสภาพแวดล้อมการทำงานที่มีส่วนร่วม เปิดกว้าง และมุ่งผลลัพธ์ พร้อมเส้นทางอาชีพที่ชัดเจน',
      employee2: 'เปิดโอกาสการพัฒนาแบบข้ามภูมิภาคและข้ามสายงาน',
      employee3: 'ส่งเสริมวัฒนธรรมองค์กรแบบนานาชาติที่โปร่งใส ให้คุณค่ากับความเป็นเจ้าของ การทำงานร่วมกัน และความเป็นเลิศ',

      // Contact Section
      contactTitle: 'ติดต่อเรา',
      contactSubtitle: 'เรายินดีต้อนรับการติดต่อจากนักลงทุน ลูกค้ารวมถึงผู้เชี่ยวชาญที่สนใจร่วมงานหรือร่วมโอกาสไปกับ VentuNext',
    },

    // Business Page
    business: {
      heroTag: 'สิ่งที่เราทำ',
      heroTitle: 'ธุรกิจของเรา',
      heroSubtitle: 'โซลูชันครบวงจรครอบคลุมห่วงโซ่คุณค่าอสังหาริมทรัพย์อุตสาหกรรม',

      bts: {
        title: 'โรงงาน/คลังสินค้าแบบสร้างตามความต้องการ (Built-to-Suit)',
        description: 'เราพัฒนาโรงงาน/คลังสินค้าแบบ Built-to-Suit ตามความต้องการของผู้เช่า ตั้งแต่การวางผังและกำหนดสเปก ไปจนถึงการขออนุญาต ก่อสร้าง และส่งมอบโครงการ ทีมงานผสานแนวคิดรองรับระบบอัตโนมัติและมาตรฐาน ESG พร้อมการควบคุมงบประมาณและระยะเวลาอย่างเคร่งครัด เพื่อช่วยให้ลูกค้าเริ่มดำเนินงานได้รวดเร็วและมีประสิทธิภาพยิ่งขึ้น',
      },
      readyBuilt: {
        title: 'โลจิสติกส์พาร์ก/คลังสินค้าสำเร็จรูป',
        description: 'เราพัฒนาโลจิสติกส์พาร์กและคลังสินค้าสำเร็จรูปในทำเลศักยภาพ เพื่อรองรับการย้ายเข้าได้ทันทีและการขยายพื้นที่ได้อย่างยืดหยุ่น โครงการดำเนินงานด้วยมาตรฐานระดับสถาบัน ครอบคลุมความปลอดภัย ระบบสาธารณูปโภค และการบริหารจัดการพื้นที่ เพื่อยกระดับประสบการณ์ผู้เช่าและคงคุณภาพสินทรัพย์ในระยะยาว',
      },
      assetMgmt: {
        title: 'การบริหารสินทรัพย์อสังหาริมทรัพย์',
        description: 'เราดูแลการบริหารสินทรัพย์แบบครบวงจร ตั้งแต่กลยุทธ์การปล่อยเช่า การดูแลความสัมพันธ์ผู้เช่า การจัดทำงบประมาณและแผนลงทุนปรับปรุง (Capex) ไปจนถึงการรายงานผลการดำเนินงานอย่างโปร่งใส ด้วยการบริหารเชิงรุกและการจัดการความเสี่ยง เรามุ่งรักษาอัตราเช่าสูง กระแสเงินสดมั่นคง และเพิ่มมูลค่าสินทรัพย์อย่างต่อเนื่อง',
      },
      fundMgmt: {
        title: 'การบริหารกองทุนเอกชน',
        description: 'เราจัดตั้งและบริหารกองทุน/ยานพาหนะการลงทุนภาคเอกชนด้านอสังหาริมทรัพย์สำหรับนักลงทุนที่มีคุณสมบัติตามเกณฑ์ โดยยึดกลยุทธ์การลงทุนที่ชัดเจน กระบวนการคัดกรองและตรวจสอบสถานะ (Due Diligence) ที่เข้มงวด และการบริหารหลังการลงทุนอย่างเป็นระบบ เป้าหมายคือสร้างผลตอบแทนที่น่าสนใจบนฐานผลตอบแทนต่อความเสี่ยง ผ่านการคัดเลือกสินทรัพย์คุณภาพ การบริหารเชิงรุก และการวางแผนทางออกที่เหมาะสม',
      },

      ctaTitle: 'ร่วมเป็นพันธมิตรกับเรา',
      ctaSubtitle: 'ไม่ว่าคุณกำลังมองหาสิ่งอำนวยความสะดวกด้านอุตสาหกรรม โอกาสในการลงทุน หรือบริการบริหารสินทรัพย์ เราพร้อมให้ความช่วยเหลือ',
    },

    // Team Page
    team: {
      heroTag: 'ผู้นำ',
      heroTitle: 'ทีมผู้บริหาร',
      heroSubtitle: 'ผู้นำที่มีประสบการณ์ในการสร้างโครงสร้างพื้นฐานอุตสาหกรรมยุคใหม่',

      introPara1: 'ทีมผู้ก่อตั้งประกอบด้วยผู้บริหารระดับสูงจากผู้พัฒนาอสังหาริมทรัพย์อุตสาหกรรมชั้นนำระดับโลกและสถาบันบริหารกองทุน โดยมีประสบการณ์ครอบคลุมศูนย์กลางโลจิสติกส์และการผลิตสำคัญทั่วเอเชีย โดยรวมแล้วทีมงานเคยบริหารพอร์ตอสังหาริมทรัพย์อุตสาหกรรมและโลจิสติกส์มูลค่ารวมมากกว่า 10,000 ล้านดอลลาร์สหรัฐ',
      introPara2: 'ตลอดหลายทศวรรษที่ผ่านมา ทีมงานได้ส่งมอบโครงการแลนด์มาร์กและสนับสนุนบริษัท Fortune Global 500 และบรรษัทข้ามชาติในหลากหลายรูปแบบ ตั้งแต่ศูนย์กระจายสินค้า โครงการโรงงานแบบสร้างตามความต้องการ (BTS) ไปจนถึงโซลูชันการบริหารสินทรัพย์ระยะยาว',

      education: 'การศึกษา',

      pengTao: {
        name: 'Peng-Tao Zhang',
        title: 'Managing Director',
        bio: [
          'Peng-Tao Zhang is the Co-Founder and Managing Director of VentuNext, where he has spearheaded the company\'s rapid growth in the Asia Pacific industrial real estate sector and led investments valued at billions of Thai Baht. He is responsible for the company\'s daily operational management, investment strategy formulation, and regional business expansion.',
          'Prior to establishing VentuNext, Peng-Tao served as Managing Director of a leading industrial real estate platform, where he directed the end-to-end development of Southeast Asia\'s largest fully automated warehouse project, which stands as one of the world\'s largest of its kind.',
          'Earlier in his career, he drove Southeast Asia expansion for YunExpress, scaled leasing and business development at GLP across over one million square meters of logistics assets, and led global accounts at FedEx Asia Pacific.'
        ],
        education: 'Peng-Tao holds a Bachelor\'s degree in Economics from Chongqing University, a Master\'s degree in International Banking and Finance from Lingnan University, and a Master\'s degree in Supply Chain and Logistics Management from the University of Warwick.'
      },

      kane: {
        name: 'Kane Chen',
        title: 'Executive Director',
        bio: [
          'Kane Chen is Co-Founder and Executive Director at VentuNext, with over 25 years of experience in industrial and logistics facilities development. He supports the firm\'s engineering strategy and project delivery across Thailand and Southeast Asia.',
          'Before joining VentuNext, Kane founded and led an engineering firm specialising in large-scale industrial and logistics projects, delivering more than three million square metres of facilities for leading logistics platforms, manufacturers and supply chain operators. He began his career at Butler / BlueScope, where he gained a strong foundation in international engineering standards and project governance.'
        ],
        education: 'Kane holds a degree in Construction Machinery from the Chongqing Institute of Architecture and Engineering.'
      },

      ctaTitle: 'ร่วมงานกับเรา',
      ctaSubtitle: 'เรากำลังมองหาผู้เชี่ยวชาญที่มีความสามารถเข้ามาร่วมทีมที่กำลังเติบโตของเรา',
      viewCareers: 'ดูโอกาสทางอาชีพ',
    },

    // Pipeline Page
    pipeline: {
      heroTag: 'โครงการของเรา',
      heroTitle: 'โครงการในแผนงาน',
      heroSubtitle: 'การพัฒนาโลจิสติกส์เชิงกลยุทธ์ในตลาดที่มีการเติบโตสูง',

      dubai: {
        name: 'VentuNext Dubai Logistics Park',
        location: 'Dubai, UAE',
        gfa: '60,000 sq.m. GFA',
        target: 'Targeted for multinational logistics operators',
        investment: 'Total Investment: USD 90 million',
      },
      samutPrakan: {
        name: 'VentuNext Samut Prakan Logistics Park',
        location: 'Samut Prakan, Thailand (EEC)',
        gfa: '100,000 sq.m. GFA',
        target: 'Targeted for multinational logistics operators & brand owners',
        investment: 'Total Investment: USD 55 million',
      },
      samutSakhon: {
        name: 'VentuNext Samut Sakhon Logistics Park',
        location: 'Samut Sakhon, Thailand',
        gfa: '40,000 sq.m. GFA',
        target: 'Targeted for multinational logistics operators',
        investment: 'Total Investment: USD 25 million',
      },

      ctaTitle: 'สนใจในโครงการของเรา?',
      ctaSubtitle: 'เรายินดีต้อนรับการติดต่อจากนักลงทุนและลูกค้าที่สนใจโอกาสในโครงการของเรา',
    },

    // Career Page
    career: {
      heroTag: 'ร่วมงานกับเรา',
      heroTitle: 'ร่วมงานกับเรา',
      heroSubtitle: 'สร้างอาชีพของคุณในการลงทุนอสังหาริมทรัพย์อุตสาหกรรม',

      programTitle: 'สร้างผู้นำรุ่นใหม่ที่กล้าคิด กล้าทำ และมุ่งเน้น',
      programTitleBold: 'คุณค่าในระยะยาว',
      programPara1: 'โครงการ NextLeap Investment Manager Programme ของ VentuNext เป็นโปรแกรมพัฒนาบุคลากรแบบองค์รวมระยะเวลา 2 ปี สำหรับผู้เริ่มต้นอาชีพที่มีความมุ่งมั่นในสายงานการลงทุนและการบริหารสินทรัพย์ โดยผู้เข้าร่วมจะได้ประสบการณ์จากงานจริง การเรียนรู้ข้ามสายงาน และการมีส่วนร่วมในโครงการลงทุน เพื่อสร้างความเข้าใจอย่างเป็นระบบเกี่ยวกับการบริหารสินทรัพย์จริง (Real Asset Management) โดยเน้นอสังหาริมทรัพย์อุตสาหกรรมและโลจิสติกส์เป็นหลัก',
      programPara2: 'นี่คือโอกาสที่คุณจะได้นำจุดแข็งและความมุ่งมั่นของตนเองมาเชื่อมโยงกับเป้าหมายร่วมของเรา คือการสร้างคุณค่าระยะยาวให้กับผู้มีส่วนได้ส่วนเสีย ผ่านการเติบโตและการลงทุนอย่างยั่งยืนและมีความรับผิดชอบ พร้อมทั้งสนับสนุนให้ชุมชนและระบบเศรษฐกิจเติบโตอย่างเข้มแข็งและมีความยืดหยุ่น',
      programPara3: 'ทีมบริหารการลงทุนและบริหารสินทรัพย์ของ VentuNext คือแรงขับเคลื่อนสำคัญของการเติบโต พวกเขาอยู่ในศูนย์กลางของกลยุทธ์และการดำเนินงาน ขับเคลื่อนผลการดำเนินงานอย่างมีวินัย ยกระดับประสิทธิภาพ และสร้างมูลค่าทางเศรษฐกิจในระยะยาว ควบคู่ไปกับการส่งเสริมผลลัพธ์เชิงบวกด้านสิ่งแวดล้อมและสังคมต่อผู้คนและพื้นที่ที่เราให้บริการ',

      offerTitle: 'สิ่งที่เรามอบให้',
      offerSubtitle: 'ร่วมทีมที่ลงทุนในการเติบโตของคุณ',

      benefit1Title: 'สภาพแวดล้อมประสิทธิภาพสูง',
      benefit1Desc: 'สภาพแวดล้อมการทำงานที่มีส่วนร่วม เปิดกว้าง และมุ่งผลลัพธ์ พร้อมเส้นทางอาชีพที่ชัดเจน',
      benefit2Title: 'ความเป็นเจ้าของที่แท้จริง',
      benefit2Desc: 'ก้าวไปอย่างรวดเร็ว และเร่งความก้าวหน้าในอาชีพผ่านความรับผิดชอบที่เหนือความคาดหมายและโอกาสข้ามภูมิภาค',
      benefit3Title: 'ประสบการณ์ระดับสากล',
      benefit3Desc: 'วัฒนธรรมองค์กรแบบนานาชาติที่โปร่งใส ให้คุณค่ากับความเป็นเจ้าของ การทำงานร่วมกัน และความเป็นเลิศ',

      ctaTitle: 'สนใจร่วมงานกับเรา?',
      ctaSubtitle: 'เรายินดีต้อนรับผู้เชี่ยวชาญที่สนใจโอกาสกับ VentuNext กรุณาติดต่อเราเพื่อเรียนรู้เพิ่มเติมเกี่ยวกับตำแหน่งงานที่เปิดรับ',
    },

    // Contact Page
    contact: {
      heroTag: 'ติดต่อเรา',
      heroTitle: 'ติดต่อเรา',
      heroSubtitle: 'เรายินดีต้อนรับการติดต่อจากนักลงทุน ลูกค้ารวมถึงผู้เชี่ยวชาญที่สนใจร่วมงานหรือร่วมโอกาสไปกับ VentuNext',

      formIntro: 'โปรดกรอกแบบฟอร์มด้านล่าง ทีมงานของเราจะติดต่อกลับหาคุณโดยเร็วที่สุด',

      steps: {
        name: "ชื่อของคุณ?",
        namePlaceholder: 'กรอกชื่อ-นามสกุล',
        email: "อีเมลของคุณ?",
        emailPlaceholder: 'your@email.com',
        company: "คุณมาจากบริษัทใด?",
        companyPlaceholder: 'ชื่อบริษัท (ไม่บังคับ)',
        enquiryType: "ประเภทการสอบถาม?",
        enquiryPlaceholder: 'กรุณาเลือก...',
        message: "เราช่วยอะไรคุณได้บ้าง?",
        messagePlaceholder: 'บอกเราเพิ่มเติมเกี่ยวกับการสอบถามของคุณ...',
      },

      enquiryTypes: {
        investor: 'สอบถามด้านการลงทุน',
        client: 'สอบถามจากลูกค้า',
        career: 'โอกาสทางอาชีพ',
        other: 'อื่น ๆ',
      },

      required: 'จำเป็นต้องกรอกข้อมูลนี้',
      back: 'ย้อนกลับ',
      continue: 'ดำเนินการต่อ',
      submit: 'ส่ง',
      thankYou: 'ขอบคุณสำหรับการสอบถาม ทีมงานของเราจะติดต่อกลับหาคุณโดยเร็วที่สุด',
    },

    // Footer
    footer: {
      tagline: 'ลงทุนในอนาคตของโครงสร้างพื้นฐานอุตสาหกรรมและโลจิสติกส์',
      company: 'บริษัท',
      about: 'เกี่ยวกับเรา',
      vision: 'วิสัยทัศน์',
      resources: 'แหล่งข้อมูล',
      ourTeam: 'ทีมงาน',
      careers: 'ร่วมงาน',
      contact: 'ติดต่อ',
      getInTouch: 'ติดต่อเรา',
      location: 'กรุงเทพฯ ประเทศไทย',
      rights: 'VentuNext สงวนลิขสิทธิ์',
      privacy: 'นโยบายความเป็นส่วนตัว',
      terms: 'ข้อกำหนดการใช้บริการ',
    },
  },
};

export default translations;
